const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftarc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 843.636,
    height: 996.691,
    viewBox: "0 0 843.636 996.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3056",
    d: "M416.4 1285.776v683.016a1367.044 1367.044 0 0 0 382.455-227.222z",
    style: {
      fill: "#45a82c"
    },
    transform: "translate(-416.398 -972.101)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3057",
    d: "M606.576 972.1A742.984 742.984 0 0 1 416.4 1242.71v43.065l382.461 455.8A1368.143 1368.143 0 0 0 1260.034 972.1z",
    style: {
      fill: "#83c522"
    },
    transform: "translate(-416.398 -972.101)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarc);
export default __webpack_public_path__ + "static/media/leftarc.2171858eac3ac6a41c3b6e27dd7235a0.svg";
export { ForwardRef as ReactComponent };